import React, { Component } from 'react'
import { ThemeProvider } from 'styled-components'
import GlobalStyle from '../theme/globalStyles'

class ThemeWrapper extends Component {
  constructor(props) {
    super(props)
    // Always start with light theme for SSR consistency
    this.state = { lightAppearance: true, isClient: false }
    this.updateAppearance = this.updateAppearance.bind(this)
  }

  updateAppearance(e) {
    if (typeof window !== 'undefined') {
      let mql = window.matchMedia('(prefers-color-scheme: light)')
      this.setState({ lightAppearance: mql.matches })
    }
  }

  componentDidMount() {
    this.setState({ isClient: true })
    if (typeof window !== 'undefined') {
      let mql = window.matchMedia('(prefers-color-scheme: light)')
      this.updateAppearance()
      mql.addEventListener('change', this.updateAppearance)
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      let mql = window.matchMedia('(prefers-color-scheme: light)')
      mql.removeEventListener('change', this.updateAppearance)
    }
  }

  render() {
    const { children } = this.props
    const { lightAppearance, isClient } = this.state

    // Use consistent theme for SSR and initial client render
    const theme = { appearance: 'light' }

    return (
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        {children}
      </ThemeProvider>
    )
  }
}

export default ThemeWrapper
